import { CashType } from '@golden/gdk-admin'

const cashTypeName: { [key in CashType]: string } = {
  [CashType.RMB]: 'RMB',
  [CashType.USDT]: 'USDT'
}

export default cashTypeName
